import { FONT } from "@/styles/common";
import { Box, Grid } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { WEEK_DAY_GROUP } from "../../constants";

export const WeekDays = () => {
    return (
        <Grid gridTemplateColumns="repeat(7, 1fr)">
            {WEEK_DAY_GROUP.map((day) => {
                return (
                    <CustomBox p="8px" key={day.weekNum} textAlign="center">
                        {day.weekDay}
                    </CustomBox>
                );
            })}
        </Grid>
    );
};

const CustomBox = styled(Box)`
    ${FONT("pretendard", 14, 500)}
`;
